/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingupdated1Inputs */

const en_listingupdated1 = /** @type {(inputs: Listingupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing updated!`)
};

const de_listingupdated1 = /** @type {(inputs: Listingupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort aktualisiert!`)
};

/**
* | output |
* | --- |
* | "Listing updated!" |
*
* @param {Listingupdated1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingupdated1 = /** @type {((inputs?: Listingupdated1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingupdated1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingupdated1(inputs)
	return de_listingupdated1(inputs)
});
export { listingupdated1 as "listingUpdated" }